import { render, staticRenderFns } from "./AppDetailTab-azure.vue?vue&type=template&id=a320aafe&scoped=true";
import script from "./AppDetailTab-azure.vue?vue&type=script&lang=js";
export * from "./AppDetailTab-azure.vue?vue&type=script&lang=js";
import style0 from "./AppDetailTab-azure.vue?vue&type=style&index=0&id=a320aafe&prod&lang=less&scoped=true";

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js";
var component = normalizer(script, render, staticRenderFns, false, null, "a320aafe", null);
export default component.exports;